export const REQUEST_STATUS = {
  NOT_FOUND: 'NOT_FOUND',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
  COMPLETED: 'COMPLETED',
}

export const getRequestStatus = (programRequestStatuses = []) => {
  if (!programRequestStatuses.length) {
    return REQUEST_STATUS.NOT_FOUND
  }

  if (programRequestStatuses.includes(REQUEST_STATUS.COMPLETED)) {
    return REQUEST_STATUS.COMPLETED
  }

  if (programRequestStatuses.includes(REQUEST_STATUS.APPROVED)) {
    return REQUEST_STATUS.APPROVED
  }

  if (programRequestStatuses.includes(REQUEST_STATUS.PENDING)) {
    return REQUEST_STATUS.PENDING
  }

  if (programRequestStatuses.includes(REQUEST_STATUS.REJECTED)) {
    return REQUEST_STATUS.REJECTED
  }
}

export const statusDescription = brand => ({
  [REQUEST_STATUS.PENDING]: {
    text: 'Your request is pending PEC approval.',
    severity: 'info',
  },
  [REQUEST_STATUS.NOT_FOUND]: {
    text: `We can't find your request. Use one of the buttons below to sign up for ${brand ||
      'PGA Family Golf'} or contact our support to get assistance.`,
    severity: 'info',
  },
  [REQUEST_STATUS.REJECTED]: {
    text:
      'Your request was rejected. You can contact our support to get assistance.',
    severity: 'error',
  },
})
